<template>
    <div class="checkout-delivery__item" :class="activeType" @click="() => {$emit('update:modelValue', item.id)}">
        <div class="checkout-delivery__item-headline">
            {{item.name}}
        </div>
        <div class="checkout-delivery__item-info">
            <span v-for="(span) in item.info"> {{span}}</span>
        </div>
        <div class="checkout-delivery__item-price">₪{{item.price}}</div>
        <div class="checkout-delivery__item-active">
            <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="3.13523" height="14.9993" rx="1" transform="matrix(0.697214 0.716863 -0.697214 0.716863 13.814 0)" fill="white"/>
                <rect width="3.13523" height="7.88965" rx="1" transform="matrix(-0.697214 0.716863 -0.697214 -0.716863 7.68677 10.7524)" fill="white"/>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DeliveryItem",
        emits: ['update:modelValue'],
        props: ['item', 'modelValue'],
        computed:{
            activeType(){
                return {
                    active: this.item.id === this.modelValue ? 'active' : ''
                }
            }
        }
    }
</script>

<style scoped>

</style>
